import {
  Col,
  Form,
  InputNumber,
  Row,
  Select,
} from "antd";
import * as S from "../Multistepform.styles";
import React from "react";
import AppartementsPricesFormList from "../components/AppartementsPricesList";
import BureauxPricesList from "../components/BureauxPricesList";
import VillasPricesList from "../components/VillasPricesList";
import LcPricesList from "../components/LcPricesList";

interface Props {
  typeDeProjet: string[];
  form: any;
  formData: any;
  setFormData: any;
}

export const InformationsDesVentesStep: React.FC<Props> = ({
  form,
  typeDeProjet,
  
  formData,
  

  setFormData,
}) => {
  // Villas handlers
  const handleVillasSoldChange = (value: number | null) => {
    if (value !== null && !isNaN(value)) {
      const remaining = Math.max(0, formData.nbr_unites_villas - value);
      setFormData((prev: any) => ({
        ...prev,
        nbr_unites_villas_vendues: value,
        nbr_unites_villas_invendues: remaining,
      }));
      form.setFieldsValue({ nbr_unites_villas_invendues: remaining });
    }
  };

  const handleVillasUnsoldChange = (value: number | null) => {
    if (value !== null && !isNaN(value)) {
      const sold = Math.max(0, formData.nbr_unites_villas - value);
      setFormData((prev: any) => ({
        ...prev,
        nbr_unites_villas_invendues: value,
        nbr_unites_villas_vendues: sold,
      }));
      form.setFieldsValue({ nbr_unites_villas_vendues: sold });
    }
  };

  // Bureaux handlers
  const handleBureauxSoldChange = (value: number | null) => {
    if (value !== null && !isNaN(value)) {
      const remaining = Math.max(0, formData.nbr_unites_bureaux - value);
      setFormData((prev: any) => ({
        ...prev,
        nbr_unites_bureaux_vendues: value,
        nbr_unites_bureaux_invendues: remaining,
      }));
      form.setFieldsValue({ nbr_unites_bureaux_invendues: remaining });
    }
  };

  const handleBureauxUnsoldChange = (value: number | null) => {
    if (value !== null && !isNaN(value)) {
      const sold = Math.max(0, formData.nbr_unites_bureaux - value);
      setFormData((prev: any) => ({
        ...prev,
        nbr_unites_bureaux_invendues: value,
        nbr_unites_bureaux_vendues: sold,
      }));
      form.setFieldsValue({ nbr_unites_bureaux_vendues: sold });
    }
  };

  // Appartements handlers
  const handleAppartmentsSoldChange = (value: number | null) => {
    if (value !== null && !isNaN(value)) {
      const remaining = Math.max(0, formData.nbr_unites_appartements - value);
      setFormData((prev: any) => ({
        ...prev,
        nbr_unites_appartements_vendues: value,
        nbr_unites_appartements_invendues: remaining,
      }));
      form.setFieldsValue({ nbr_unites_appartements_invendues: remaining });
    }
  };

  const handleAppartmentsUnsoldChange = (value: number | null) => {
    if (value !== null && !isNaN(value)) {
      const sold = Math.max(0, formData.nbr_unites_appartements - value);
      setFormData((prev: any) => ({
        ...prev,
        nbr_unites_appartements_invendues: value,
        nbr_unites_appartements_vendues: sold,
      }));
      form.setFieldsValue({ nbr_unites_appartements_vendues: sold });
    }
  };

  // Locaux commerciaux handlers
  const handleLCSoldChange = (value: number | null) => {
    if (value !== null && !isNaN(value)) {
      const remaining = Math.max(0, formData.nbr_unites_lc - value);
      setFormData((prev: any) => ({
        ...prev,
        nbr_unites_lc_vendues: value,
        nbr_unites_lc_invendues: remaining,
      }));
      form.setFieldsValue({ nbr_unites_lc_invendues: remaining });
    }
  };

  const handleLCUnsoldChange = (value: number | null) => {
    if (value !== null && !isNaN(value)) {
      const sold = Math.max(0, formData.nbr_unites_lc - value);
      setFormData((prev: any) => ({
        ...prev,
        nbr_unites_lc_invendues: value,
        nbr_unites_lc_vendues: sold,
      }));
      form.setFieldsValue({ nbr_unites_lc_vendues: sold });
    }
  };

  return (
    <>
      

      {/* Prix des appartements       */}
      {typeDeProjet.includes("appartements") && (
        
          <Row
            gutter={16}
            style={{ width: "100%", paddingLeft: "10px", paddingRight: "10px" }}
          >
            <S.SpanLined>
              Appartements (total: {formData.nbr_unites_appartements} unités)
            </S.SpanLined>
            <Row
              style={{
                width: "100%",
                paddingLeft: "10px",
                paddingRight: "10px",
              }}
              gutter={16}
              justify={"space-between"}
            >
              <Col xs={24} sm={24} md={12} lg={12}>
                <Form.Item
                  name="nbr_unites_appartements_vendues"
                  label="Nombre d'unités vendues"
                  rules={[
                    {
                      required: true,
                      message: "Veuillez saisir le nombre d'unités vendues",
                    },
                  ]}
                >
                  <InputNumber
                    style={{ width: "100%" }}
                    min={0}
                    max={formData.nbr_unites_appartements}
                    value={formData.nbr_unites_appartements_vendues}
                    onChange={handleAppartmentsSoldChange}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12}>
                <Form.Item
                  name="nbr_unites_appartements_invendues"
                  label="Nombre d'unités invendues"
                  rules={[
                    {
                      required: true,
                      message: "Veuillez saisir le nombre d'unités invendues",
                    },
                  ]}
                >
                  <InputNumber
                    style={{ width: "100%" }}
                    min={0}
                    max={formData.nbr_unites_appartements}
                    value={formData.nbr_unites_appartements_invendues}
                    onChange={handleAppartmentsUnsoldChange}
                  />
                </Form.Item>
              </Col>
            </Row>
            <AppartementsPricesFormList
              form={form}
              formData={formData}
              setFormData={setFormData}
            />
          </Row>
      )}

      {/* villas       */}
      {typeDeProjet.includes("villas") && (
          <Row
            gutter={16}
            style={{ width: "100%", paddingLeft: "10px", paddingRight: "10px" }}
          >
            <S.SpanLined>
              Villas (total: {formData.nbr_unites_villas} unités)
            </S.SpanLined>
            <Row
              style={{
                width: "100%",
                paddingLeft: "10px",
                paddingRight: "10px",
              }}
              gutter={16}
              justify={"space-between"}
            >
              <Col xs={24} sm={24} md={12} lg={12}>
                <Form.Item
                  name="nbr_unites_villas_vendues"
                  label="Nombre d'unités vendues"
                  rules={[
                    {
                      required: true,
                      message: "Veuillez saisir le nombre d'unités vendues",
                    },
                  ]}
                >
                  <InputNumber
                    style={{ width: "100%" }}
                    min={0}
                    max={formData.nbr_unites_villas}
                    value={formData.nbr_unites_villas_vendues}
                    onChange={handleVillasSoldChange}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12}>
                <Form.Item
                  name="nbr_unites_villas_invendues"
                  label="Nombre d'unités invendues"
                  rules={[
                    {
                      required: true,
                      message: "Veuillez saisir le nombre d'unités invendues",
                    },
                  ]}
                >
                  <InputNumber
                    style={{ width: "100%" }}
                    min={0}
                    max={formData.nbr_unites_villas}
                    value={formData.nbr_unites_villas_invendues}
                    onChange={handleVillasUnsoldChange}
                  />
                </Form.Item>
              </Col>
            </Row>

            <VillasPricesList
              form={form}
              formData={formData}
              setFormData={setFormData}
            />
          </Row>
      )}

      {/* bureaux       */}

      {typeDeProjet.includes("bureaux") && (
          <Row
            gutter={16}
            style={{ width: "100%", paddingLeft: "10px", paddingRight: "10px" }}
          >
            <S.SpanLined>
              Bureaux (total: {formData.nbr_unites_bureaux} unités)
            </S.SpanLined>
            <Row
              style={{
                width: "100%",
                paddingLeft: "10px",
                paddingRight: "10px",
              }}
              gutter={16}
              justify={"space-between"}
            >
              <Col xs={24} sm={24} md={12} lg={12}>
                <Form.Item
                  name="nbr_unites_bureaux_vendues"
                  label="Nombre d'unités vendues"
                  rules={[
                    {
                      required: true,
                      message: "Veuillez saisir le nombre d'unités vendues",
                    },
                  ]}
                >
                  <InputNumber
                    style={{ width: "100%" }}
                    min={0}
                    max={formData.nbr_unites_bureaux}
                    value={formData.nbr_unites_bureaux_vendues}
                    onChange={handleBureauxSoldChange}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12}>
                <Form.Item
                  name="nbr_unites_bureaux_invendues"
                  label="Nombre d'unités invendues"
                  rules={[
                    {
                      required: true,
                      message: "Veuillez saisir le nombre d'unités invendues",
                    },
                  ]}
                >
                  <InputNumber
                    style={{ width: "100%" }}
                    min={0}
                    max={formData.nbr_unites_bureaux}
                    value={formData.nbr_unites_bureaux_invendues}
                    onChange={handleBureauxUnsoldChange}
                  />
                </Form.Item>
              </Col>
            </Row>
            <BureauxPricesList
              form={form}
              formData={formData}
              setFormData={setFormData}
            />
          </Row>
      )}

      {/* locaux commerciaux       */}
      {typeDeProjet.includes("locaux commerciaux") && (
    
          <Row
            gutter={16}
            style={{ width: "100%", paddingLeft: "10px", paddingRight: "10px" }}
          >
            <S.SpanLined>
              Locaux commerciaux (total: {formData.nbr_unites_lc} unités)
            </S.SpanLined>
            <Row
              style={{
                width: "100%",
                paddingLeft: "10px",
                paddingRight: "10px",
              }}
              gutter={16}
              justify={"space-between"}
            >
              <Col xs={24} sm={24} md={12} lg={12}>
                <Form.Item
                  name="nbr_unites_lc_vendues"
                  label="Nombre d'unités vendues"
                  rules={[
                    {
                      required: true,
                      message: "Veuillez saisir le nombre d'unités vendues",
                    },
                  ]}
                >
                  <InputNumber
                    style={{ width: "100%" }}
                    min={0}
                    max={formData.nbr_unites_lc}
                    value={formData.nbr_unites_lc_vendues}
                    onChange={handleLCSoldChange}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12}>
                <Form.Item
                  name="nbr_unites_lc_invendues"
                  label="Nombre d'unités invendues"
                  rules={[
                    {
                      required: true,
                      message: "Veuillez saisir le nombre d'unités invendues",
                    },
                  ]}
                >
                  <InputNumber
                    style={{ width: "100%" }}
                    min={0}
                    max={formData.nbr_unites_lc}
                    value={formData.nbr_unites_lc_invendues}
                    onChange={handleLCUnsoldChange}
                  />
                </Form.Item>
              </Col>
            </Row>
            <LcPricesList
              form={form}
              formData={formData}
              setFormData={setFormData}
            />
          </Row>
      )}
    </>
  );
};
